import ProfileBlock from "./ProfileBlock";

export * from "./ProfileBlock";

export default ProfileBlock;